
    <h2 mat-dialog-title style="color: #424242;">Edit Clock-in and Clock-out Times</h2>
    <div mat-dialog-content>
      <!-- Clock-in Time Section -->
      <div style="margin-bottom: 25px;">
        <h3 style="margin: 0 0 10px 0; color: #8bc34a; font-size: 16px;font-weight: 600;">Clock-in Time</h3>
        <div style="margin-bottom: 10px;">
          <label style="display: block; margin-bottom: 5px; font-weight: 500;">Current Time:
            <span style="color: #666; margin: 0;">{{data.clockInDisplay}}</span>
          </label>
        </div>
        <div>
          <label style="display: block; margin-bottom: 5px; font-weight: 500;">New Time:</label>
          <input type="time"
                 [(ngModel)]="clockInTime"
                 [disabled]="isLoading"
                 style="width: 100%; padding: 8px; border: 1px solid #ddd; border-radius: 4px;">
        </div>
      </div>

      <!-- Clock-out Time Section -->
      <div style="margin-bottom: 25px;">
        <h3 style="margin: 0 0 10px 0; color: #8bc34a; font-size: 16px;font-weight: 600;">Clock-out Time</h3>
        <div style="margin-bottom: 10px;">
          <label style="display: block; margin-bottom: 5px; font-weight: 500;">Current Time:
            <span style="color: #666; margin: 0;">{{data.clockOutDisplay}}</span>
          </label>
        </div>
        <div>
          <label style="display: block; margin-bottom: 5px; font-weight: 500;">New Time:</label>
          <input type="time"
                 [(ngModel)]="clockOutTime"
                 [disabled]="isLoading"
                 style="width: 100%; padding: 8px; border: 1px solid #ddd; border-radius: 4px;">
        </div>
      </div>

      <div style="margin-bottom: 20px;">
        <label style="display: block; margin-bottom: 5px; font-weight: 500;">Reason for Change: <span style="color: red;">*</span></label>
        <textarea [(ngModel)]="reason"
                  [disabled]="isLoading"
                  placeholder="Please provide a reason for this time change..."
                  style="width: 100%; height: 80px; padding: 8px; border: 1px solid #ddd; border-radius: 4px; resize: vertical;"
                  required></textarea>
      </div>
    </div>
    <div *ngIf="showDayStart" style="margin-bottom: 15px; color: red; font-weight: 600;">
      Daystart: {{ day.daystart | date:'short' }} - Dayend: {{ day.dayend | date:'short' }}
    </div>

    <div mat-dialog-actions style="justify-content: flex-end; gap: 10px;">
      <button mat-button (click)="onCancel()" [disabled]="isLoading" style="color: #666;">Cancel</button>
      <button mat-button (click)="onSave()"
              [disabled]="!reason || isLoading"
              style="background-color: #8bc34a; color: white; position: relative;">
        <span *ngIf="!isLoading">Save Changes</span>
        <span *ngIf="isLoading" style="display: flex; align-items: center; gap: 8px;">
          <mat-spinner [diameter]="20" style="display: inline-block;"></mat-spinner>
          Saving...
        </span>
      </button>
    </div>
  